import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../ui/button';
import { LayoutDashboard, Building2, Users, Database, LogOut, Sun, Moon, Antenna, ListChecks, ShieldCheck, BookOpen } from 'lucide-react';
import { useState } from 'react';

const platformNav = [
  { path: '/platform', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { path: '/platform/tenants', icon: Building2, label: 'Tenants' },
  { path: '/platform/users', icon: Users, label: 'Users' },
  { path: '/platform/sources', icon: Database, label: 'Sources' },
  { path: '/platform/jobs', icon: ListChecks, label: 'Jobs' },
  { path: '/platform/security', icon: ShieldCheck, label: 'Sécurité' },
  { path: '/platform/docs', icon: BookOpen, label: 'Documentation' },
  { path: '/platform/diagnostic', icon: Antenna, label: 'Diagnostic' },
];

export function PlatformLayout({ title, children }) {
  const { logout, user } = useAuth();
  const location = useLocation();
  const [dark, setDark] = useState(document.documentElement.classList.contains('dark'));

  const toggleTheme = () => {
    document.documentElement.classList.toggle('dark');
    setDark(!dark);
  };

  return (
    <div className="flex h-screen bg-background">
      {/* Sidebar */}
      <aside className="w-56 shrink-0 border-r bg-card flex flex-col">
        <div className="p-4 border-b">
          <div className="flex items-center gap-2">
            <Antenna className="w-5 h-5 text-rose-500" />
            <span className="font-bold text-sm">Clone IA Platform</span>
          </div>
          <p className="text-[11px] text-muted-foreground mt-1">Console d'administration</p>
        </div>

        <nav className="flex-1 p-2 space-y-0.5">
          {platformNav.map(item => {
            const Icon = item.icon;
            const isActive = item.end
              ? location.pathname === item.path
              : location.pathname.startsWith(item.path);
            return (
              <NavLink key={item.path} to={item.path} data-testid={`platform-nav-${item.label.toLowerCase()}`}>
                <div className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${isActive
                  ? 'bg-primary text-primary-foreground font-medium'
                  : 'text-muted-foreground hover:bg-muted hover:text-foreground'}`}>
                  <Icon className="w-4 h-4" />
                  <span>{item.label}</span>
                </div>
              </NavLink>
            );
          })}
        </nav>

        <div className="p-3 border-t space-y-2">
          <div className="flex items-center justify-between px-2">
            <span className="text-xs text-muted-foreground truncate">{user?.email}</span>
            <Button variant="ghost" size="icon" className="h-7 w-7" onClick={toggleTheme}>
              {dark ? <Sun className="w-3.5 h-3.5" /> : <Moon className="w-3.5 h-3.5" />}
            </Button>
          </div>
          <Button variant="ghost" className="w-full justify-start gap-2 text-sm h-8 text-muted-foreground"
            onClick={logout} data-testid="platform-logout">
            <LogOut className="w-4 h-4" /> Déconnexion
          </Button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto">
        <div className="border-b bg-card/50 px-6 py-4">
          <h1 className="text-lg font-semibold">{title}</h1>
        </div>
        <div className="p-6">{children}</div>
      </main>
    </div>
  );
}
